var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutlook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.76781 1.10723C8.66094 1.01911 8.51937 0.982544 8.3825 1.00786L0.8825 2.41411C0.660312 2.45536 0.5 2.64848 0.5 2.87442V13.1869C0.5 13.4119 0.660312 13.606 0.8825 13.6472L8.3825 15.0535C8.41062 15.0591 8.44063 15.0619 8.46875 15.0619C8.57656 15.0619 8.68344 15.0244 8.76781 14.9541C8.87563 14.865 8.9375 14.7319 8.9375 14.5932V1.46817C8.9375 1.32848 8.87563 1.19629 8.76781 1.10723ZM8 14.0279L1.4375 12.7979V3.26348L8 2.03348V14.0279Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.71875 5.68692C3.42687 5.68692 2.375 6.94879 2.375 8.49942C2.375 10.05 3.42687 11.3119 4.71875 11.3119C6.01063 11.3119 7.0625 10.05 7.0625 8.49942C7.0625 6.94879 6.01063 5.68692 4.71875 5.68692ZM4.71875 10.3744C3.94344 10.3744 3.3125 9.53348 3.3125 8.49942C3.3125 7.46536 3.94344 6.62442 4.71875 6.62442C5.49406 6.62442 6.125 7.46536 6.125 8.49942C6.125 9.53348 5.49406 10.3744 4.71875 10.3744Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0312 3.81192H8.46875C8.21 3.81192 8 4.02192 8 4.28067C8 4.53942 8.21 4.74942 8.46875 4.74942H14.5625V11.3119H8.46875C8.21 11.3119 8 11.5219 8 11.7807C8 12.0394 8.21 12.2494 8.46875 12.2494H15.0312C15.29 12.2494 15.5 12.0394 15.5 11.7807V4.28067C15.5 4.02192 15.29 3.81192 15.0312 3.81192Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4006 3.99192C15.2403 3.78755 14.9459 3.75005 14.7434 3.91036L10.7844 6.98911L8.72 5.67567C8.50343 5.53786 8.21281 5.60161 8.07312 5.82005C7.93437 6.03848 7.99906 6.32817 8.21656 6.46692L10.5603 7.95755C10.6372 8.0063 10.7253 8.03067 10.8125 8.03067C10.9137 8.03067 11.0159 7.99786 11.0994 7.9313L15.3181 4.65005C15.5234 4.49067 15.56 4.1963 15.4006 3.99192Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlook);
export default __webpack_public_path__ + "static/media/outlook.b6511dcf8d68a038cb5fcd852eff954c.svg";
export { ForwardRef as ReactComponent };